import { ClientReferenceUploadMessage, IconGroup } from '../Types/Notifications.types';
import { AppDispatch } from '../../app/store';
import { fetchNotificationsByJobid, fetchNotificationsByUser, setNewNotification } from '../Slices/Notifications.slice';
import { Messages } from '../../Constants/Messages';
import { setReferenceFileUpload } from '../../pages/admin/Lists/ReferenceTable/ReferenceTable.slice';
import { showSuccessSnackbar } from '../../component/snackbar/Snackbar.slice';
import { Guid } from 'guid-typescript';

export function addClientReferenceSuccessNotification(
	clientReferenceUploadMessage: ClientReferenceUploadMessage,
	dispatch: AppDispatch,
) {
	const isGuid = Guid.isGuid(clientReferenceUploadMessage.groupId);
	isGuid && dispatch(fetchNotificationsByJobid(clientReferenceUploadMessage.groupId));
	showSuccessSnackbar(dispatch, Messages.REFERENCE_TABLE_UPDATED_SUCCESSFULLY);
	dispatch(setReferenceFileUpload(true));
	dispatch(setNewNotification());
}

export function addClientReferenceFailureNotification(
	clientReferenceUploadMessage: ClientReferenceUploadMessage,
	dispatch: AppDispatch,
) {
	dispatch(setReferenceFileUpload(true));
	const isGuid = Guid.isGuid(clientReferenceUploadMessage.groupId);
	isGuid && dispatch(fetchNotificationsByJobid(clientReferenceUploadMessage.groupId));
	dispatch(setNewNotification());
}

export function addUserClientReferenceSuccessNotification(
	clientReferenceUploadMessage: ClientReferenceUploadMessage,
	dispatch: AppDispatch,
) {
	dispatch(setReferenceFileUpload(true));
	dispatch(fetchNotificationsByUser());
	dispatch(setNewNotification());
}

export function addUserClientReferenceFailureNotification(
	clientReferenceUploadMessage: ClientReferenceUploadMessage,
	dispatch: AppDispatch,
) {
	dispatch(setReferenceFileUpload(true));
	dispatch(fetchNotificationsByUser());
	dispatch(setNewNotification());
}
